export const branchSyncLabelKey = (upToDate?: boolean) => {
	if (upToDate === true) return 'DEPLOYMENT_PACKAGES_UP_TO_DATE' as const
	if (upToDate === false) return 'DEPLOYMENT_PACKAGES_OUT_OF_DATE' as const
	return null
}
